import PropTypes from 'prop-types';
import React, { useCallback, useMemo, useState } from 'react';
import { connect } from 'react-redux';

import Loading from '@components/Share/Loading';
import { GET_LOGIN_OTP_USE_FOR_REGISTER_KEY } from '@components/SingleSignOn/RegisterLogin/Login/RequireVerifyLoginForm/LoginWithPhone/services/useGetLoginOtp';
import { useResendLoginOtp } from '@components/SingleSignOn/RegisterLogin/Login/RequireVerifyLoginForm/LoginWithPhone/services/useResendLoginOtp';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import Global from '@utils/global';

import { useVerifyPhoneNumberUpdate } from './index';

const mapStateToProps = (state) => ({
  updateProfileMessage: state.singleSignOnReducer.updateAccountReducer.message,
  isUpdateProfileError: state.singleSignOnReducer.updateAccountReducer.isError
});

export const ValidatePhoneNumber = connect(mapStateToProps)(() => {
  const VALIDATE_OTP_MESSAGE_TYPE_ERROR = 'error';

  const { inputData, formikValues, fieldPhoneCode, setFieldValue } = useVerifyPhoneNumberUpdate();
  const resendLoginOtpService = useResendLoginOtp();

  const initialValidateOtpMessage = {
    type: '',
    message: ''
  };
  const [validateOtpMessage, setValidateOtpMessage] = useState(initialValidateOtpMessage);
  const [isCheckingOtpValue, setIsCheckingOtpValue] = useState(false);
  const [resentOtpMessage, setResentOtpMessage] = useState('');

  const phoneNumberValue = useMemo(
    () => (fieldPhoneCode?.current?.code ? `${fieldPhoneCode.current.code.replace('+', '')}${formikValues.phone}` : formikValues.phone),
    [fieldPhoneCode, formikValues.phone]
  );

  const handleResetMessageStates = useCallback(() => {
    setResentOtpMessage('');

    setValidateOtpMessage(initialValidateOtpMessage);
  }, []);

  const handleChangeOtpInput = useCallback((event) => setFieldValue('otp', event.target.value), [setFieldValue]);

  const handleResendLoginOtp = useCallback(async () => {
    setIsCheckingOtpValue(true);

    handleResetMessageStates();
    try {
      const resendOtpResponse = await resendLoginOtpService(phoneNumberValue, GET_LOGIN_OTP_USE_FOR_REGISTER_KEY);
      if (resendOtpResponse) {
        setValidateOtpMessage(initialValidateOtpMessage);

        setResentOtpMessage(inputData?.['OTP Sent Message']?.value);
      }
    } catch (error) {
      setValidateOtpMessage({
        type: VALIDATE_OTP_MESSAGE_TYPE_ERROR,
        message: error
      });
    } finally {
      setIsCheckingOtpValue(false);
    }
  }, [phoneNumberValue, inputData]);

  return (
    <>
      <div
        className={Global.renderDynamicClass(
          validateOtpMessage.type === VALIDATE_OTP_MESSAGE_TYPE_ERROR && validateOtpMessage.message,
          'form-group',
          'input-error-validate'
        )}
      >
        <Text tag='p' field={inputData?.['OTP Sent Message']} className='form-group__label-text' />
        <div className='form-group--group-wrap'>
          <div className='form-group--input'>
            <input
              type='text'
              className={Global.renderDynamicClass(formikValues?.otp, 'form-control form-control-lg', 'input-valid')}
              onChange={handleChangeOtpInput}
              placeholder={inputData?.['OTP Input']?.value}
            />
          </div>
        </div>

        {validateOtpMessage.message ? (
          <span className={validateOtpMessage.type === VALIDATE_OTP_MESSAGE_TYPE_ERROR ? 'error-validate' : 'message-successful'}>
            {validateOtpMessage.message}
          </span>
        ) : resentOtpMessage ? (
          <span className='message-successful'>{resentOtpMessage}</span>
        ) : (
          <></>
        )}

        <div className='form-group osim-account-form__form__resend-otp register-form'>
          <button type='button' className='resend-otp-btn' onClick={handleResendLoginOtp}>
            <Text field={inputData['Resend Text']} />
          </button>
        </div>

        {isCheckingOtpValue ? <Loading /> : <></>}
      </div>
    </>
  );
});

ValidatePhoneNumber.propTypes = {
  updateProfileMessage: PropTypes.string,
  isUpdateProfileError: PropTypes.bool
};
